import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { rupiah } from "@/lib/format";
import { PageHeader } from "@/components/app/Layout";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function LabaRugi() {
  const [tahun, setTahun] = useState(new Date().getFullYear());
  const [d, setD] = useState(null);
  useEffect(()=>{ api.get("/laporan/laba-rugi", {params:{tahun}}).then(r=>setD(r.data)); },[tahun]);
  if(!d) return null;
  return (<>
    <PageHeader title="Laporan Laba Rugi" subtitle={`Periode: Tahun ${tahun}`}/>
    <div className="p-4 md:p-8 space-y-6">
      <div className="card-flat p-4 max-w-xs"><Label>Tahun</Label><Input type="number" value={tahun} onChange={(e)=>setTahun(Number(e.target.value)||tahun)}/></div>
      <div className="card-flat">
        <table className="w-full text-sm">
          <tbody>
            <tr className="bg-slate-50 border-b"><td colSpan="2" className="p-3 font-semibold brand-text">PENDAPATAN</td></tr>
            {d.pendapatan.map(x=>(<tr key={"p"+x.kategori} className="border-b"><td className="p-3 pl-8">{x.kategori}</td><td className="p-3 text-right font-mono">{rupiah(x.jumlah)}</td></tr>))}
            <tr className="border-b bg-blue-50 font-semibold"><td className="p-3">Total Pendapatan</td><td className="p-3 text-right font-mono brand-text">{rupiah(d.total_pendapatan)}</td></tr>
            <tr className="bg-slate-50 border-b"><td colSpan="2" className="p-3 font-semibold text-rose-700">BEBAN</td></tr>
            {d.beban.map(x=>(<tr key={"b"+x.kategori} className="border-b"><td className="p-3 pl-8">{x.kategori}</td><td className="p-3 text-right font-mono">{rupiah(x.jumlah)}</td></tr>))}
            <tr className="border-b bg-rose-50 font-semibold"><td className="p-3">Total Beban</td><td className="p-3 text-right font-mono text-rose-700">({rupiah(d.total_beban)})</td></tr>
            <tr className={`font-bold text-base ${d.laba_bersih>=0?"bg-emerald-100":"bg-rose-100"}`}><td className="p-4">LABA BERSIH</td><td className="p-4 text-right font-mono">{rupiah(d.laba_bersih)}</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  </>);
}
